/**
 * @class
 */
import Base from 'netxcore@netx/core/lib/netx-view';

import {icon} from '@fortawesome/fontawesome-svg-core';

import CartBarActionsTemplate from '@netx/core-app/templates/menuView-cartBarActions.html';
import ContextTemplate from '@netx/core-app/templates/menuView-context.html';
import {Menus} from '@netx/core/legacyMenuManager';

// currently these are the only menu views that can be used
// but themes can override the templates
const MenuTemplates = {
	context: ContextTemplate,
	cartBarActions: CartBarActionsTemplate,
};

class View extends Base {
	/** @override */
	constructor(opts = {}) {
		super(opts);

		this.icons = opts.icons || {};
	}

	/** @override */
	preRender() {
		Object.assign(this.templateVars, {icons: this.icons});

		super.preRender();
	}

	/** @method */
	initializedIcons() {
		// All icons in this view have been installed
	}

	/**
	 * Material menus
	 * @override
	 */
	insertContextMenu(menuName, e) {
		const menuOptions = {
			className: 'context-menu mdc-menu-surface--anchor',
			model: this.model,
			collection: this.menuCollection || this.collection,
			context: true,
			menu: Menus[menuName],
			removeOnHide: true,
			materialMenus: {
				autoOpen: true,
			},
		};

		// Look for custom template
		const templateName = (this.$el.attr('data-nx-template') || '').replace(
			'menuView-',
			'',
		);
		if (templateName != null) {
			menuOptions.template = MenuTemplates[templateName];
		}

		// Menu view type
		const menuView = (this.menuView = new Netx.Views.MenuView(menuOptions));
		menuView.el.style.top = e.pageY + 'px';
		menuView.el.style.left = e.pageX + 'px';
		document.body.appendChild(menuView.el);
		menuView.render();

		// iOS safari has some real issues
		// if we do not do something here the menu will either hide immediately
		// or an action that is now beneath your finger will fire
		if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
			document.body.style.pointerEvents = 'none';
			_.delay(() => {
				document.body.style.pointerEvents = 'initial';
			}, 300);
		}
	}

	/** @override */
	remove() {
		delete this.icons;
		super.remove();
	}

	/**
	 * @method
	 * @static
	 */
	static initializeIcons(icons, opts) {
		const iconOpts = {classes: ['fa-fw'], ...opts};
		Object.entries(icons).map(([name, faIcon]) => {
			icons[name] = icon(faIcon, iconOpts).html;
		});
		return icons;
	}
}

export default View;
